import { getGlobal, getAnalyticsClient } from './helpers';

/**
 * The Bing analytics client factory function that sets up the `trackEvent`,
 * `trackConverion` and/or `trackUser` methods orchestrated by the upstream
 * analytics provider.
 *
 * @kind function
 * @name bing
 * @sig {k: v} -> (* -> undefined) -> Boolean -> {k: v}
 * @param {Object} config The analytics config that contains the required bing `id` (which is provided to Carvana for our paid enterprise account)
 * @param {Function} log An optional logging method that unless it is undefined will always collect the event name and data.
 * @param {Boolean} noPublish Whether or not to send the event to the remote analytics service (or the global script attached to the same app).  This is mainly for debugging, never for production.
 * @returns {Object} An object containing the `trackEvent` and/or `trackConversion` implementations
 */
function bing(config = {}, log, noPublish) {
  const { id, ...restOfConfig } = config;
  return {
    async trackConversion(eventName, eventData = {}) {
      const trackConversionBing = await getAnalyticsClient('uetq', '//bat.bing.com/bat.js', uetq => {
        const UET = getGlobal('UET');
        restOfConfig.q = uetq;
        // odd name bing gives for their `id` field
        restOfConfig.ti = restOfConfig.ti || id;
        return new UET(restOfConfig);
      });

      if (trackConversionBing) {
        if (log) {
          log('[Analytics_Bing_Conversion]', { eventName, eventData });
        }

        if (!noPublish) {
          const { _evt, _abf, ...newProps } = eventData;
          trackConversionBing.push(newProps);
        }
      }
    }
  };
}

export default bing;
